import { $ } from '@/libs/jquery/index'

// region Валидация срока действия карты
const validateCardExpire = (row: JQuery): boolean => {
  const now = new Date()
  const month = parseInt(row.find('[data-rule-cardexpiremonth]').val().toString() || '0', 10) || 0
  const year = parseInt(row.find('[data-rule-cardexpireyear]').val().toString() || '0', 10) || 0
  let minYear = now.getFullYear() % 1000
  let minMonth = now.getMonth() + 2 // следующий месяц в формате от 1 до 12

  if (minMonth > 12) {
    minMonth = 1
    minYear = minYear + 1
  }
  if (year > minYear) {
    minMonth = 1
  }
  // месяц в диапазоне от 1 до 12
  const isMonthValid = (month >= minMonth && month <= 12)
  // год больше текущего
  const isYearValid = (year >= minYear)

  return isMonthValid && isYearValid
}
// endregion

$.validator.addMethod('cardexpiremonth', function(value: string, element: HTMLElement): boolean {
  return this.optional(element) || validateCardExpire($(element).closest('.formRequestField'))
}, 'Укажите верное значение')

$.validator.addMethod('cardexpireyear', function(value: string, element: HTMLElement): boolean {
  return this.optional(element) || validateCardExpire($(element).closest('.formRequestField'))
}, 'Укажите верное значение')
